import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const MarketsLayout = lazy(() => import('@/pages/markets/layout'));
const MarketsPage = lazy(() => import('@/pages/markets'));
const CreateMarketPage = lazy(() => import('@/pages/markets/create'));
const MarketLayout = lazy(() => import('@/pages/markets/[marketId]/layout'));
const UpdateMarketPage = lazy(() => import('@/pages/markets/[marketId]/update'));
const ViewMarketPage = lazy(() => import('@/pages/markets/[marketId]/view'));

export const marketRoutes: RouteConfig = {
  path: '/markets',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: MarketsLayout,
      children: [
        {
          path: '',
          element: MarketsPage,
        },
        {
          path: '/create',
          element: CreateMarketPage,
        },
        {
          path: '/:marketId',
          layout: MarketLayout,
          children: [
            {
              path: '/view',
              element: ViewMarketPage,
            },
            {
              path: '/update',
              element: UpdateMarketPage,
            },
          ],
        },
      ],
    },
  ],
};
